import React from "react";
import Routes from "./routes";
import "./styles/global.css";
import routes from "./routes";
import { SSOContext } from "./contexts/SSOContext";
import { useRoutes } from "react-router-dom";
import { Provider } from "react-redux";

import { store } from "./components/redux/store";
import { SSOProvider } from "./contexts/SSOContext";
import { OperacaoProvider } from "./context/OperacaoContext";

function App() {
  const content = useRoutes(routes);

  return (
    <Provider store={store}>
      <SSOProvider>
        <OperacaoProvider>
          {content}
        </OperacaoProvider>
      </SSOProvider>
    </Provider>

  );
}

export default App;
